(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const theme = window.theme;

  /* ---------- Dinero ---------- */
  const money = (cents) => {
    const format = theme.moneyFormat || '${{amount}}';
    const token = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    const build = (decimals, thousands, decimal) => {
      const [int, frac] = (cents / 100).toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    const formats = {
      amount: () => build(2, ',', '.'),
      amount_no_decimals: () => build(0, ',', '.'),
      amount_with_comma_separator: () => build(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => build(0, '.', ','),
      amount_with_apostrophe_separator: () => build(2, "'", '.'),
      amount_no_decimals_with_space_separator: () => build(0, ' ', ','),
      amount_with_space_separator: () => build(2, ' ', ','),
      amount_with_period_and_space_separator: () => build(2, ' ', '.')
    };
    return format.replace(/\{\{\s*\w+\s*\}\}/, (formats[token] || formats.amount)());
  };

  /* ---------- Carrito ---------- */
  const cart = {
    open() {
      document.documentElement.classList.add('cart-open');
    },
    close() {
      document.documentElement.classList.remove('cart-open');
    },
    render(html) {
      const current = $('#shopify-section-cart-drawer');
      if (!current || !html) return;
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('#shopify-section-cart-drawer');
      if (!next) return;
      current.innerHTML = next.innerHTML;
      const count = Number($('#CartDrawer')?.dataset.count || 0);
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
    },
    async change(key, quantity) {
      const response = await fetch(`${theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer' })
      });
      const data = await response.json();
      if (response.ok) cart.render(data.sections?.['cart-drawer']);
    }
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cart-open]');
    if (opener && theme.cartType === 'drawer' && $('#CartDrawer')) {
      event.preventDefault();
      cart.open();
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      cart.close();
      return;
    }
    const change = event.target.closest('[data-cart-change]');
    if (change) {
      $('#CartDrawer')?.classList.add('is-busy');
      cart
        .change(change.dataset.cartChange, Number(change.dataset.qty))
        .finally(() => $('#CartDrawer')?.classList.remove('is-busy'));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') cart.close();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-ajax-form]');
    if (!form || theme.cartType === 'page') return;
    event.preventDefault();

    const button = $('[type="submit"]', form);
    const error = $('[data-error]', form);
    if (error) error.hidden = true;
    button?.classList.add('is-loading');

    try {
      const body = new FormData(form);
      body.append('sections', 'cart-drawer');
      const response = await fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message);

      if (theme.cartType === 'checkout' || !$('#CartDrawer')) {
        window.location.href = theme.cartType === 'checkout' ? theme.routes.checkout : theme.routes.cart;
        return;
      }
      cart.render(data.sections?.['cart-drawer']);
      cart.open();
    } catch (err) {
      if (error) {
        error.textContent = err.message;
        error.hidden = false;
      }
    } finally {
      button?.classList.remove('is-loading');
    }
  });

  /* ---------- Selector de idioma ---------- */
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-auto-submit]')) event.target.form.submit();
  });

  /* ---------- Carruseles (galería, testimonios, videos) ---------- */
  const initSlider = (root) => {
    const track = $('[data-track]', root);
    if (!track) return null;
    const slides = $$('[data-slide]', track);
    const thumbs = $$('[data-thumb]', root);
    const prev = $('[data-prev]', root);
    const next = $('[data-next]', root);
    const step = () => (slides[0]?.getBoundingClientRect().width || track.clientWidth) + (parseFloat(getComputedStyle(track).columnGap) || 0);
    const index = () => Math.round(track.scrollLeft / step());
    const go = (i) => {
      const target = slides[Math.max(0, Math.min(i, slides.length - 1))];
      if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    const sync = () => {
      const i = index();
      thumbs.forEach((thumb, n) => thumb.classList.toggle('is-active', n === i));
      thumbs[i]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };

    prev?.addEventListener('click', () => go(index() - 1));
    next?.addEventListener('click', () => go(index() + 1));
    thumbs.forEach((thumb, n) => thumb.addEventListener('click', () => go(n)));
    if (thumbs.length) {
      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(sync);
      }, { passive: true });
    }
    return { go, slides };
  };

  const sliders = new Map();

  /* Todo lo que depende del contenido de una sección: se repite cuando el editor de temas la recarga */
  const init = (scope) => {
    $$('[data-slider]', scope).forEach((root) => sliders.set(root, initSlider(root)));

    /* ---------- Producto ---------- */
    $$('[data-product]', scope).forEach((root) => {
      const source = $('[data-variants]', root);
      if (!source) return;
      const variants = JSON.parse(source.textContent);
      const idInput = $('input[name="id"]', root);
      const qtyInput = $('input[name="quantity"]', root);
      const gallery = sliders.get($('[data-slider]', root));
      let current = variants.find((variant) => String(variant.id) === idInput?.value) || variants[0];

      /* Precio de un pack: el precio fijo de la variante si existe; si no, el porcentaje
         (igual que Shopify: por unidad y redondeado hacia abajo) */
      const packPrice = (input) => {
        const qty = Number(input?.dataset.qty || 1);
        const fixed = Number((input?.dataset.prices || '').split(',')[variants.indexOf(current)]);
        if (fixed > 0) return fixed;
        const pct = Number(input?.dataset.pct || 0);
        return (current.price - Math.floor((current.price * pct) / 100)) * qty;
      };

      const render = () => {
        const tier = $('[data-tier]:checked', root);
        const qty = Number(tier?.dataset.qty || 1);
        const available = Boolean(current?.available);

        if (current) {
          const unitCompare = Math.max(current.compare_at_price || 0, current.price);
          const price = packPrice(tier);
          const compare = unitCompare * qty;
          const saved = compare > price ? Math.round(((compare - price) * 100) / compare) : 0;

          $$('[data-price]', root).forEach((el) => (el.innerHTML = money(price)));
          $$('[data-compare]', root).forEach((el) => {
            el.hidden = !saved;
            el.innerHTML = saved ? money(compare) : '';
          });
          $$('[data-save]', root).forEach((el) => {
            el.hidden = !saved;
            el.textContent = theme.strings.save.replace('[x]', saved);
          });
          $$('[data-tier][data-qty]', root).forEach((input) => {
            const row = input.closest('.tier');
            const tierQty = Number(input.dataset.qty);
            const tierPrice = packPrice(input);
            const tierCompare = unitCompare * tierQty;
            $('[data-tier-price]', row).innerHTML = money(tierPrice);
            $('[data-tier-compare]', row).innerHTML = tierCompare > tierPrice ? money(tierCompare) : '';
          });
          if (idInput) idInput.value = current.id;
        }
        if (qtyInput) qtyInput.value = qty;

        $$('[data-atc]', root).forEach((button) => {
          button.disabled = !available;
          const label = $('[data-atc-label]', button);
          if (label) label.textContent = available ? button.dataset.label : current ? theme.strings.soldOut : theme.strings.unavailable;
        });
      };

      const select = (variant) => {
        current = variant;
        render();
        if (!variant) return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        const mediaId = variant.featured_media?.id;
        const slide = mediaId && gallery?.slides.findIndex((el) => el.dataset.mediaId === String(mediaId));
        if (Number.isInteger(slide) && slide >= 0) gallery.go(slide);
      };

      root.addEventListener('change', (event) => {
        const input = event.target;
        if (input.matches('[data-option]')) {
          const chosen = $$('[data-option-group]', root).map((group) => $('[data-option]:checked', group)?.value);
          select(variants.find((variant) => variant.options.every((value, i) => value === chosen[i])));
        } else if (input.matches('[data-tier][data-variant]')) {
          select(variants.find((variant) => String(variant.id) === input.dataset.variant));
        } else if (input.matches('[data-tier]')) {
          render();
        }
      });

      render();

      /* Versión preseleccionada (si el enlace no pide una variante concreta) */
      const preferred = $('[data-option][data-default]', root);
      if (preferred && !preferred.checked && !new URLSearchParams(window.location.search).has('variant')) {
        preferred.checked = true;
        preferred.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /* Barra fija de compra */
      const sticky = $('[data-sticky]', root);
      const main = $('[data-atc-main]', root);
      if (sticky && main) {
        sticky.hidden = false;
        new IntersectionObserver(([entry]) => {
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', passed);
          document.documentElement.classList.toggle('has-sticky', passed);
        }).observe(main);
        $('[data-sticky-btn]', sticky)?.addEventListener('click', () => main.form.requestSubmit(main));
      }
    });

    /* ---------- Fecha estimada de entrega ---------- */
    $$('[data-delivery]', scope).forEach((el) => {
      const format = (days) => {
        const date = new Date();
        if (el.dataset.business === 'true') {
          for (let left = Number(days); left > 0; ) {
            date.setDate(date.getDate() + 1);
            if (date.getDay() !== 0 && date.getDay() !== 6) left--;
          }
        } else {
          date.setDate(date.getDate() + Number(days));
        }
        return date.toLocaleDateString(document.documentElement.lang || undefined, { day: 'numeric', month: 'long' });
      };
      $('[data-delivery-text]', el).innerHTML = el.dataset.text
        .replace('[inicio]', `<strong>${format(el.dataset.min)}</strong>`)
        .replace('[fin]', `<strong>${format(el.dataset.max)}</strong>`);
    });

    /* ---------- Cuenta regresiva (se reinicia sola) ---------- */
    $$('[data-countdown]', scope).forEach((el) => {
      const duration = Number(el.dataset.countdown) * 60 * 1000;
      const key = 'theme-countdown-end';
      const read = () => {
        try {
          return Number(sessionStorage.getItem(key));
        } catch (e) {
          return 0;
        }
      };
      const write = (value) => {
        try {
          sessionStorage.setItem(key, value);
        } catch (e) {}
      };
      let end = read();
      const tick = () => {
        if (!end || end <= Date.now()) {
          end = Date.now() + duration;
          write(end);
        }
        const left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        el.textContent = `${String(Math.floor(left / 60)).padStart(2, '0')}:${String(left % 60).padStart(2, '0')}`;
      };
      tick();
      setInterval(tick, 1000);
    });

    /* ---------- Antes / después ---------- */
    $$('[data-ba]', scope).forEach((el) => {
      $('input', el).addEventListener('input', (event) => el.style.setProperty('--pos', `${event.target.value}%`));
    });

    /* ---------- Contadores de estadísticas ---------- */
    const counters = $$('[data-count-to]', scope);
    if (counters.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          const el = entry.target;
          const target = Number(el.dataset.countTo);
          const start = performance.now();
          const frame = (now) => {
            const progress = Math.min(1, (now - start) / 1200);
            el.textContent = Math.round(target * (1 - Math.pow(1 - progress, 3)));
            if (progress < 1) requestAnimationFrame(frame);
          };
          requestAnimationFrame(frame);
        });
      }, { threshold: 0.4 });
      counters.forEach((el) => observer.observe(el));
    }

  };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  /* ---------- Videos de testimonios ---------- */
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-video-toggle]');
    if (!toggle) return;
    const wrap = toggle.closest('[data-video]');
    const video = $('video', wrap);
    if (!video) return;
    if (video.paused) {
      $$('[data-video] video').forEach((other) => {
        if (other !== video) {
          other.pause();
          other.closest('[data-video]').classList.remove('is-playing');
        }
      });
      video.play();
      wrap.classList.add('is-playing');
    } else {
      video.pause();
      wrap.classList.remove('is-playing');
    }
  });
})();
